import React from 'react';
import classNames from 'classnames';
import './Jumbotron.less';

const Jumbotron = ({backgroundImage, className, title, children}) => {
    return (
        <div>
            <div
                className={classNames('jumbotron text-center', className)}
                style={{backgroundImage: `url(${backgroundImage})`}}
            >
                <div className="container">
                    {title && (
                        <h1
                            className="text-white"
                            dangerouslySetInnerHTML={{__html: title}}
                        />
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Jumbotron;
